import * as constants from '../constants/actions';
import * as storage from '../persistance/storage';

const initialState = {
  uid: storage.get('uid'),
  token: storage.get('token'),
  expiry: storage.get('tokenExpiry'),
  hideData: true,
  secondAuth: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.AUTH_SAVE:
      return authSave(state, action);
    case constants.AUTH_HIDE_DATA:
      return authToggleHide(state, action);
    case constants.AUTH_SET_SECOND:
      return authSetSecond(state, action);
    default:
      return state;
  }
}

function authSave(state, action) {
  return Object.assign({}, state, {
    token: action.token,
    admin: action.admin,
    role: action.role,
    tokenExpiry: action.tokenExpiry,
    uid: action.uid, 
  });
}

function authToggleHide(state, action) {
  return Object.assign({}, state, {
    hideData: !state.hideData,
  });
}

function authSetSecond(state, action) {
  return Object.assign({}, state, {
    secondAuth: Date.now(),
  });
}